
import React from "react";
import { AddAssignment } from "@/components/gestion/AddAssignment";

const AddAssignmentPage = () => {
  return <AddAssignment />;
};

export default AddAssignmentPage;
